import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "custom-dropdown" }
const _hoisted_2 = {
  key: 0,
  class: "dropdown-menu w-full mt-1 bg-gray-700 border border-gray-600 rounded-md max-h-60 overflow-y-auto absolute z-10"
}
const _hoisted_3 = { class: "py-2 px-3 bg-gray-800 text-white font-medium border-b border-gray-600" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 1,
  class: "py-1.5 pl-5 pr-3 text-gray-400 text-sm italic"
}
const _hoisted_7 = {
  key: 1,
  class: "mt-1 text-sm text-red-500"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-300 mb-1" }, "Kategorija *", -1)),
    _createElementVNode("div", {
      class: _normalizeClass(["dropdown-toggle w-full bg-gray-700 border border-gray-600 rounded-md py-2 px-3 text-white focus:outline-none focus:ring-2 focus:ring-green-500 flex justify-between items-center cursor-pointer", { 'border-red-500': _ctx.error }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isOpen = !_ctx.isOpen))
    }, [
      _createElementVNode("span", null, _toDisplayString(_ctx.displayCategoryPath || 'Izaberite kategoriju'), 1),
      _cache[1] || (_cache[1] = _createElementVNode("svg", {
        class: "w-4 h-4 text-gray-400",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        _createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M19 9l-7 7-7-7"
        })
      ], -1))
    ], 2),
    (_ctx.isOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
            return (_openBlock(), _createElementBlock("div", {
              key: category.id
            }, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(category.name), 1),
              (category.children && category.children.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.children, (child) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: child.id,
                        class: "py-1.5 pl-5 pr-3 hover:bg-gray-600 cursor-pointer text-white text-sm",
                        onClick: ($event: any) => (_ctx.selectCategory(child.id, child.name, category.name))
                      }, _toDisplayString(child.name), 9, _hoisted_5))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, " Nema podkategorija "))
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true)
  ]))
}